import styled, { keyframes } from 'styled-components';
import Card from '@components/card';
import { Link } from 'react-router-dom';

export const DetailedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 124px);
`;

export const DetailedHeader = styled.div`
    display: flex;
    padding: 48px 24px;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 100%;
    box-sizing: border-box;
    flex-wrap: wrap;
`;

export const BackButton = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: ${({ $CARD_BACKGROUND_COLOR }) =>
        $CARD_BACKGROUND_COLOR};
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    will-change: transform;

    @media (max-width: 768px) {
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
    }
    transition: all 0.3s ease;
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2),
        inset 0 0 1px 1px rgba(255, 255, 255, 0.1);

    &:hover {
        transform: translateY(-4px);
        background: ${({ $isDarkMode }) =>
            $isDarkMode
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(255, 255, 255, 0.55)'};
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.2),
            inset 0 0 1px 1px rgba(255, 255, 255, 0.1);
    }

    &:active {
        transform: translateY(-1px);
    }
`;

export const DetailedTitleBox = styled.div.attrs(
    ({ background }) => ({
        style: {
            background,
        },
    })
)`
    display: flex;
    align-items: center;
    padding: 10px 40px;
    border-radius: 32px;
    cursor: default;
    user-select: none;
`;

export const DetailedHeaderText = styled.div`
    font-size: 22px;
    margin-left: 12px;
`;

export const DetailedBodyWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    > div {
        width: 250px;
        height: 250px;
        margin: 20px;
    }
`;

export const DetailedCardWrapper = styled(Card)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const DetailedCardLogoWrapper = styled.div`
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 48px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
`;

export const DetailedCardLogo = styled.img`
    height: ${({ widthBased }) =>
        widthBased ? 'auto' : '120px'};
    width: ${({ widthBased }) =>
        widthBased ? '120px' : 'auto'};
`;

export const DetailedCardTitle = styled.div`
    font-size: 16px;
    margin: 12px 6px 0;
    text-align: center;
`;

export const DetailedModalWrapper = styled.div`
    position: relative;
    outline: none;
    width: 90%;
    max-width: 1400px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    background: ${({ $MODAL_BACKGROUND_COLOR }) =>
        $MODAL_BACKGROUND_COLOR};
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) =>
            $CARD_BORDER_COLOR || 'rgba(255, 255, 255, 0.1)'};
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    will-change: transform;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.4),
        inset 0 0 1px 1px rgba(255, 255, 255, 0.1);

    @media (max-width: 768px) {
        width: 95%;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
    }

    img {
        width: 100%;
        max-height: 70vh;
        object-fit: contain;
        display: block;
        border-radius: 40px;
    }

    @media (max-width: 1024px) {
        width: 95%;
        border-radius: 32px;

        img {
            border-radius: 32px;
        }
    }
`;

export const DetailedModalText = styled.div`
    position: absolute;
    bottom: -48px;
    left: 50%;
    transform: translateX(-50%);
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};
    background: ${({ $isDarkMode }) =>
        $isDarkMode
            ? 'rgba(20, 20, 30, 0.75)'
            : 'rgba(255, 255, 255, 0.8)'};
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    padding: 8px 24px;
    border-radius: 20px;
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) =>
            $CARD_BORDER_COLOR || 'rgba(255, 255, 255, 0.1)'};
    font-size: 14px;
    white-space: nowrap;
    text-align: center;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2),
        inset 0 0 1px 1px rgba(255, 255, 255, 0.1);
    z-index: 10;
    pointer-events: none;

    @media (min-width: 768px) {
        font-size: 16px;
        bottom: -54px;
        padding: 10px 28px;
    }

    @media (min-width: 1024px) {
        font-size: 17px;
    }
`;

const blobSpin = keyframes`
    0% {
        transform: rotate(0deg) scale(1);
        border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
    }
    50% {
        transform: rotate(180deg) scale(1.1);
        border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
    }
    100% {
        transform: rotate(360deg) scale(1);
        border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
    }
`;

export const ImageLoaderWrapper = styled.div`
    width: 100%;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    @media (min-width: 768px) {
        height: 280px;
    }

    @media (min-width: 1024px) {
        height: 300px;
    }
`;

export const ModalBlobLoader = styled.div`
    width: 60px;
    height: 60px;
    position: relative;

    &::before,
    &::after {
        content: '';
        position: absolute;
        inset: 0;
        filter: blur(10px);
        opacity: 0.8;
    }

    &::before {
        background: radial-gradient(
            circle,
            rgba(0, 188, 212, 0.8) 0%,
            rgba(123, 31, 162, 0.4) 100%
        );
        animation: ${blobSpin} 4s linear infinite;
    }

    &::after {
        background: radial-gradient(
            circle,
            rgba(255, 64, 129, 0.7) 0%,
            rgba(0, 188, 212, 0.3) 100%
        );
        animation: ${blobSpin} 6s linear infinite reverse;
    }
`;
